/* Episode Silver - Rakhi landing page behaviour
   Loaded by sections/rakhi-landing.liquid. */
/* Smooth scroll for the hero button.

   Native hash navigation does not scroll on this theme, so the jump is done
   explicitly. scrollIntoView applies the target's own scroll-margin-top, which
   is what clears the sticky header, so there is no JS offset arithmetic here.
   Earlier attempts on the corporate page failed precisely because they tried to
   compute that offset by hand. */
(function () {
  var cta = document.querySelector('.rakhi-hero__cta[href^="#"]');
  if (!cta) { return; }
  cta.addEventListener('click', function (event) {
    var id = cta.getAttribute('href').slice(1);
    var target = document.getElementById(id);
    if (!target) { return; }
    event.preventDefault();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    try {
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    } catch (e) {
      target.scrollIntoView();
    }
    if (window.history && window.history.pushState) {
      window.history.pushState(null, '', '#' + id);
    }
  });
})();

/* Hold the gift set cards on their first photograph.

   The store runs an image swap app (gravity-apps image_swapmyepi5225.js) which,
   on hover, rewrites a product image's src and srcset to the product's second
   photograph and adds object-fit: contain as an inline style. On a collection
   page that is a second look at the same product and it is wanted. Here the
   second photograph of every set is the gift box, so the card silently turns
   into a picture of a box and stops looking like the product it names.

   The swap is done in JavaScript, so CSS cannot prevent it. This watches only
   the eight cards on this page and puts the three attributes back the moment
   anything changes them. Nothing else on the store is touched, and the app
   keeps working everywhere else.

   Putting src back triggers another mutation record, but the guard compares
   before writing, so the second pass finds the attributes already correct and
   stops. No loop. The scale on hover, which is the animation the card should
   have, is plain CSS in episode-rakhi.css and is unaffected. */
(function () {
  var cards = document.querySelectorAll('.rakhi-card__image');
  if (!cards.length || !window.MutationObserver) { return; }

  var watched = ['src', 'srcset', 'style'];

  Array.prototype.forEach.call(cards, function (img) {
    var original = {};
    watched.forEach(function (name) {
      original[name] = img.getAttribute(name);
    });

    new MutationObserver(function () {
      watched.forEach(function (name) {
        var want = original[name];
        if (img.getAttribute(name) === want) { return; }
        if (want === null) {
          img.removeAttribute(name);
        } else {
          img.setAttribute(name, want);
        }
      });
    }).observe(img, { attributes: true, attributeFilter: watched });
  });
})();
